import documentsIcon from "../../../../../assets/images/description.svg";
import useLanguageTranslate from "../../../../../hooks/useLanguageTranslate";
import BottomStickyBtnLayout from "../../../layouts/BottomStickyBtnLayout";
import PersonalCyberJourneyLayout from "../../../layouts/PersonalCyberJourneyLayout";
import "./documentsReadyInfo.css";
import InfoCard from "./infoCard";

const DocumentsReadyInfo = ({
  continueClickHandler,
  hide_back_btn = true,
  show_close_btn = false,
  onClose,
  customBackHandler,
  isFirstPage = false,
}) => {
  const translate = useLanguageTranslate();

  return (
    <div className="w-full">
      <PersonalCyberJourneyLayout
        show_close_btn={show_close_btn}
        onClose={onClose}
        is_hide_back_btn={hide_back_btn}
        customBackHandler={customBackHandler}
        isFirstPage={isFirstPage}
      >
        <BottomStickyBtnLayout
          btn_onClick={continueClickHandler}
          btn_label={translate("Continue", "التالي")}
        >
          <div className="w-[32%] max767:w-full mx-auto ipad:min-w-[66%] pb-5 max767:px-6">
            <h1 className="text-[#1A2024] text-center text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] max767:text-left max767:rtl:text-right">
              {translate(
                "Ready to Start Your New Policy?",
                "هل أنت مستعد لبدء وثيقتك الجديدة؟"
              )}
            </h1>
            <p className="text-[#1A2024] text-center text-base not-italic font-normal leading-6 tracking-[-0.16px] mb-6 max767:text-left max767:rtl:text-right">
              {translate(
                "Please ensure you have the following information and documents ready for smooth process.",
                "يرجى التأكد من أن لديك المعلومات والمستندات التالية جاهزة لعملية سلسة."
              )}
            </p>
            <div className="infoCards mb-6">
              <InfoCard
                title={translate("Required Documents", "المستندات")}
                title_icon={documentsIcon}
                infoData={[
                  {
                    en_label: "CPR Bahraini National ID",
                    ar_label: "رقم بطاقة الهوية (CPR)",
                    hasInfo: false,
                  },
                ]}
              />
            </div>
          </div>
        </BottomStickyBtnLayout>
      </PersonalCyberJourneyLayout>
    </div>
  );
};

export default DocumentsReadyInfo;
